import { useCallback, useSyncExternalStore } from 'react';

function getSnapshot(query: string) {
  return window.matchMedia(query).matches;
}

function getServerSnapshot() {
  return false;
}

function subscribe(onChange: () => void, query: string) {
  const mql = window.matchMedia(query);
  mql.addEventListener('change', onChange);

  return () => {
    mql.removeEventListener('change', onChange);
  };
}

/**
 * React hook to evaluate a media query and subscribe to its changes.
 * https://julesblom.com/writing/usesyncexternalstore#usemediaquery
 * @param {string} query - The media query string to evaluate.
 * @returns {boolean} - True if the media query matches, false otherwise.
 */
export function useMediaQuery(query: string) {
  const subscribeMediaQuery = useCallback(
    (onChange: () => void) => {
      return subscribe(onChange, query);
    },
    [query]
  );

  const matches = useSyncExternalStore(
    subscribeMediaQuery,
    () => getSnapshot(query),
    getServerSnapshot
  );

  return matches;
}
